var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('w-button',{attrs:{"tooltip-size":"small","color":"text","tooltip":_vm.$t('commentScreenCreator.button.screen'),"icon":"monitor","tooltip-position":'bottom',"size":_vm.size},on:{"click":function($event){$event.stopPropagation();return _vm.startScreenCommentRecording.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }